<!--
	Brain's DialogChrome in the frame's regions: the heading, the error band, the message and the two
	footer actions, Cancel first (`DialogChrome.tsx:130-137`). No close control: Cancel is the way out.
-->
<eff-clarity-dialog-frame
	[heading]="title"
	[tone]="tone"
	[error]="error()"
	[closable]="false"
	dsTestId="clarity-confirm-dialog"
>
	<p class="slds-no-space" dsTestId="clarity-confirm-dialog-message">{{ message }}</p>

	<footer data-slot="footer" horizontal="end" class="eff-gap--sm">
		<eff-button
			variant="outlined"
			tone="neutral"
			size="sm"
			[disabled]="isLoading()"
			dsTestId="clarity-confirm-dialog-cancel"
			(clicked)="onClose()"
		>
			{{ cancelLabel }}
		</eff-button>
		<eff-button
			variant="filled"
			size="sm"
			[tone]="confirmTone"
			[disabled]="isConfirmDisabled()"
			dsTestId="clarity-confirm-dialog-confirm"
			(clicked)="onConfirm()"
		>
			{{ confirmText() }}
		</eff-button>
	</footer>
</eff-clarity-dialog-frame>
